<template>
  <v-progress-linear v-if="isLoading" indeterminate />
  <div v-else class="rounded" :style="`position: relative; height: calc(100vh - ${$vuetify.breakpoint.mobile ? 56 + 32 : 92
    }px); overflow: auto`">
    <v-card v-if="!userObj.profilePicture">
      <v-card-text>
        <v-alert color="warning" class="mt-2 font-weight-bold text-center">
          Please upload your profile picture
          <v-btn x-small color="white" light to="/settings">here</v-btn>
        </v-alert>
      </v-card-text>
    </v-card>
    <!-- Payment Warning in case of No Package Purchased on Signup -->
    <v-alert class="text-left" dense border="left" type="warning" v-if="showPaymentWarningAlert">
      To book an appointment or purchase a package, you need to add a payment
      method. Please click
      <v-btn x-small color="white" light depressed rounded to="/add-payment">
        here
      </v-btn>
      to add a payment method.
      <!-- <span v-if="totalUtilizedHours >= freeBookings">You have used your free bookings.</span> -->
    </v-alert>
    <!-- Add this new alert for users with appointments -->
    <v-alert class="text-center" dense border="left" type="info" v-if="!isAdmin && hasAppointments">
      You're already assigned to an instructor.
      <v-btn x-small color="white" light depressed rounded to="/student-bookings">
        Click to create direct booking
      </v-btn>
    </v-alert>
    <v-card v-if="schoolPackageJoinedId" style="position: sticky; top: 0; z-index: 1">
      <v-card-title class="primary white--text font-weight-bold mb-3">
        <v-avatar size="40" class="mr-3">
          <img :src="signature" alt="" />
        </v-avatar>
        {{ this.schoolName }}
      </v-card-title>
      <v-card-text>
        <h3>
          So far you have completed
          <strong>{{ totalCompletedHours }}</strong> hour(s) of driving lessons
        </h3>
        <p class="mb-3 mt-3">
          The list of instructors are following you can book your appointment
          with.
        </p>
      </v-card-text>
      <v-progress-linear :indeterminate="isLoading" :value="Math.min((totalCompletedHours * 100) / 10, 100)"
        color="primary" height="20">
        <small class="font-weight-bold">
          {{ totalCompletedHours >= 10 ? '100%' : Math.ceil((totalCompletedHours * 100) / 10) + '%' }}
        </small>
      </v-progress-linear>
    </v-card>

    <QuestionnaireLayout class="not-centred">
      <v-card class=" custom-card">
        <h2 class="white--text">
          Good {{ greeting }}, {{ userObj && userObj.firstName }}!
        </h2>
        <p class="white--text ">
          Start your journey with DriverX by clicking the button below
        </p>

        <v-card-actions class="pa-4">
          <!-- <v-btn small color="primary" class="mr-3" to="/get-started">
          Search instructors
        </v-btn> -->
          <v-dialog v-model="errorModal" width="500">
            <v-card>
              <div class="px-5 py-5">
                <p class="text-center">
                  {{ this.errorMessage }}
                </p>
                <div class="text-center">
                  <v-btn small color="secondary" class="secondary-btn" @click="closeErrorModal">
                    Ok
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-dialog>

          <v-row class="justify-center flex-column">
            <v-bottom-sheet v-model="sheet" persistent scrollable>
              <template v-slot:activator>
                <v-btn x-large rounded class="mt-2 font-weight-bold center-btn" @click="openSheet">
                  Request your first driving lesson
                </v-btn>
              </template>
              <v-card>
                <v-toolbar flat dark color="primary" class="mb-8">
                  <v-spacer />
                  <v-btn icon dark @click="closeSheet">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-form class="scroll-holder">
                  <div class="px-5 text-box">
                    <h1 class="mb-3">Schedule your lesson</h1>
                    <p>Choose your suitable date and time</p>
                    <div class="box mb-5">
                      <label>
                        <input type="radio" name="like" v-model="like" value="1" />
                        <span class="yes">1 Hour Lesson</span>
                      </label>
                      <label>
                        <input type="radio" name="like" v-model="like" value="2" />
                        <span class="no">2 Hour Lesson</span>
                      </label>
                    </div>
                    <div class="scroll-box mb-5">
                      <div v-for="(date, index) in nextSevenDays" :key="index" class="box time-box">
                        <h2 class="mb-3">{{ formatDate(date) }}</h2>
                        <template v-if="availabilityOptionsByDate[index] && availabilityOptionsByDate[index].length">
                          <label v-for="(slot, sIdx) in availabilityOptionsByDate[index]" :key="`${index}-${sIdx}`">
                            <input type="radio" :name="'like' + index" v-model="selectedTimes[index]"
                              :value="slot.start" />
                            <span :class="sIdx === 0 ? 'yes' : 'no'">
                              {{ slot.label }}
                            </span>
                          </label>
                        </template>
                        <p v-else class="text-caption grey--text mb-2">
                          No saved availability for this day. first add your availability in your profile.
                        </p>
                      </div>
                    </div>
                    <v-btn small color="primary" class="mr-3 mb-5" @click="submitAvailability">{{
                      this.isSubmitingAvailibility ? "Please Wait..." : "Submit"
                    }}</v-btn>

                    <v-dialog v-model="errorDialogModal" width="500">
                      <v-card>
                        <div class="px-5 py-5">
                          <p class="text-center">
                            Thank you, your lesson will be scheduled with an
                            instructor based on your selected availability. You
                            will receive a notification within 24 hours confirming
                            your lesson. Your booking will also appear on your
                            Bookings tab.
                          </p>
                          <div class="text-center">
                            <v-btn small color="secondary" class="secondary-btn" @click="closeModal">
                              Ok
                            </v-btn>
                          </div>
                        </div>
                      </v-card>
                    </v-dialog>

                    <v-btn small color="secondary" class="mr-3 mb-5 secondary-btn" @click="sheet = false">
                      Cancel
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </v-bottom-sheet>

            <v-bottom-sheet v-model="sheet2" persistent scrollable>
              <template v-slot:activator>
                <v-btn x-large rounded class="mt-2 font-weight-bold center-btn" @click="openSheet2">
                  Book Road Test
                </v-btn>
              </template>
              <v-card>
                <v-toolbar flat dark color="primary" class="mb-8">
                  <v-spacer />
                  <v-btn icon dark @click="closeSheet2">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <div class="modal-content-holder">
                  <v-row class="ceterRow">
                    <v-col>
                      <h2 class="mb-5 text-center">Have you book a roadtest?</h2>
                      <div class="btn-row">
                        <v-btn class="mb-4" small @click="openSheet3">
                          <span>
                            <h3 class="d-block">Yes</h3>
                            <p class="mb-0">
                              I have and it's at least 3 days from now
                            </p>
                          </span>
                        </v-btn>
                        <v-btn small ref="No" @click="openSheet">
                          <span>
                            <h3>No</h3>
                            <p class="mb-0">
                              I have and its atleast 3 days from now
                            </p>
                          </span>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
              <v-bottom-sheet v-model="sheet3" persistent scrollable>
                <v-card>
                  <v-toolbar flat dark color="primary" class="mb-8">
                    <v-spacer />
                    <v-btn icon dark @click="closeSheet3">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-row justify="center" class="ceterRow modal-content-holder">
                    <v-col>
                      <v-card-text>
                        <h2 class="mb-5 text-center">
                          Which city do you want to take your test in?
                        </h2>
                        <v-form>
                          <v-col class="pb-0 mb-4">
                            <v-autocomplete dense v-model="city" :items="filteredCities" outlined
                              label="Please type city name" :hide-selected="false" :search-input.sync="populateCities"
                              hide-no-data />
                          </v-col>
                          <v-btn small color="primary" class="mr-3" :disabled="!city" @click="submitCity">{{
                            this.isSubmitingAvailibility ? "Please wait ..." : "Submit" }}</v-btn>
                          <v-btn small color="secondary" @click="closeSheet3" class="secondary-btn">
                            Cancel
                          </v-btn>
                        </v-form>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>
              </v-bottom-sheet>
            </v-bottom-sheet>
          </v-row>
        </v-card-actions>
      </v-card>
    </QuestionnaireLayout>

    <!-- Assigned Instructors Section -->
    <AssignedInstructors v-if="assignedInstructors && assignedInstructors.length > 0" :instructors="assignedInstructors"
      :school-package-id="schoolPackageId" @view-instructor="handleViewInstructor" class="mt-4" />

    <!-- <InstructorCard
      v-for="instructor in instructors"
      :key="instructor.id"
      :instructor="instructor"
      :option="option"
      :schoolPackageId="schoolPackageId"
      @update:option="option = $event"
    /> -->
    <!-- <div class="mt-4" :style="`overflow-y: auto; max-height: calc(100vh - ${$vuetify.breakpoint.mobile ? 212 + 56 + 40 : 200}px)`">
      <InstructorCard
        v-for="instructor in instructors"
        :key="instructor.id"
        :instructor="instructor"
        :option="option"
        :schoolPackageId="schoolPackageId"
        @update:option="option = $event"
      />
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuestionnaireLayout from '@/components/qauestionnaire/QuestionnaireLayout'
import AssignedInstructors from '@/components/student/AssignedInstructors'
import rawCities from 'cities.json' // https://github.com/lutangar/cities.json
import Parse from 'parse'
import { DAY_ORDER, defaultDays, mapAvailabilityRowsToDays } from '@/utils/studentAvailabilityShared'
const selectedCities = rawCities
  .filter(({ country }) => country === 'CA')
  .map(({ name }) => name)

console.log(selectedCities)

export default {
  components: {
    QuestionnaireLayout,
    AssignedInstructors
  },
  data() {
    return {
      userContinue: '',
      like: '1',
      initialPaymentWarning: true,
      isLoading: false,
      option: 'booking_lesson',
      schoolPackageId: null,
      schoolName: '',
      totalUtilizedHours: 0,
      totalCompletedHours: 0,
      filteredCityEntries: [],
      instructors: [],
      sheet: false,
      sheet2: false,
      sheet3: false,
      errorDialogModal: false,
      errorModal: false,
      errorMessage: '',
      selectedTimes: Array(31).fill(null),
      weeklyAvailabilityDays: defaultDays(),
      isSubmitingAvailibility: false,
      populateCities: null,
      city: '',
      selectedRoadTest: false,
      prePaid: false,
      paymentMethodAdded: false,
      freeBookingAvailable: false,
      appointmentsCount: 0,
      freeBookings: 0
    }
  },
  watch: {
    populateCities(value) {
      console.log('Hre', value)
      value?.length && (this.filteredCityEntries = selectedCities)
    }
  },
  computed: {
    filteredCities() {
      console.log(this.filteredCityEntries)
      return this.filteredCityEntries
    },
    ...mapGetters([
      'user',
      'userObj',
      'schoolPackageJoinedId',
      'schoolInstructors',
      'instructorPackage',
      'completedHours',
      'assignedInstructors'
    ]),
    availabilityOptionsByDate() {
      return this.nextSevenDays.map((date) => {
        const jsDay = date.getDay() // 0..6, Sun..Sat
        const key = DAY_ORDER[(jsDay + 6) % 7] // convert to mon..sun keys
        const day = (this.weeklyAvailabilityDays || []).find(d => d.key === key)

        if (!day || !day.start || !day.end) return []

        return [
          {
            start: day.start, // e.g. "7:00 AM"
            end: day.end,     // e.g. "12:00 PM"
            label: `${day.start} - ${day.end}`
          }
        ]
      })
    },
    nextSevenDays() {
      const days = []
      for (let i = 0; i < 31; i++) {
        const date = new Date()
        date.setDate(date.getDate() + 7 + i)
        days.push(date)
      }
      return days
    },
    hasAppointments() {
      return this.appointmentsCount > 0
    },
    isAdmin() {
      return this.userObj && this.userObj.role === 'admin'
    },
    showPaymentWarningAlert() {
      return (
        (this.totalUtilizedHours >= this.freeBookings || this.freeBookings === 0) &&
        !this.paymentMethodAdded
      )
    }
  },
  methods: {

    async submitAvailability() {
      console.log('Submit Availibiliity Function Hit ===')
      this.isSubmitingAvailibility = true
      console.log('Hours selectetd  == ', this.like)

      const availability = this.selectedTimes
        .map((time, index) => {
          if (time) {
            const date = new Date()
            date.setDate(date.getDate() + 7 + index)
            return {
              start: this.formatDateTime(date, time)
            }
          }
        })
        .filter((item) => item)

      if (availability.length === 0) {
        alert('Please select at least one time slot.')
        return
      }
      console.log('Formatted Availability:', availability)
      try {
        await this.storeBookingRequest({
          userId: this.user.id,
          username: `${this.user.get('firstName')} ${this.user.get(
            'lastName'
          )}`,
          hoursLesson: this.like,
          availability: availability,
          schoolPackageJoinedId: this.schoolPackageJoinedId?.id,
          schoolName: this.schoolName,
          schoolPackageId: this.schoolPackageId,
          roadTest: this.selectedRoadTest
        })
        this.freeBookingAvailable = await this.studentFreeBookingsAvailale(this.user.id)
        this.isSubmitingAvailibility = false
        this.selectedTimes = Array(31).fill(null)
        this.sheet = false
        this.openModal()
      } catch (error) {
        this.isSubmitingAvailibility = false
        this.errorMessage = `${error}`
        this.errorModal = true
        console.log('Error in storeBookingRequest =', error)
      }
    },
    async loadWeeklyAvailability() {
      try {
        const user = Parse.User.current()
        if (!user) return
        const Availability = Parse.Object.extend('StudentAvailability')
        const q = new Parse.Query(Availability)
        q.equalTo('studentId', user)
        q.limit(20)
        const rows = await q.find()
        this.weeklyAvailabilityDays = mapAvailabilityRowsToDays(rows)
      } catch (e) {
        console.error('loadWeeklyAvailability error:', e)
        this.weeklyAvailabilityDays = defaultDays()
      }
    },
    async submitCity() {
      try {
        /** Send an email as well */

        const eData = {
          contact:
            'city of ' +
            this.city +
            ', ' +
            this.user.get('email') +
            ' and cell# ' +
            this.user.get('phone'),
          type: 'Student',
          city: this.city,
          name: `${this.user.get('firstName')} ${this.user.get(
            'lastName'
          )}`
        }
        console.log('EData  === ', eData)
        /** call the cloud fundtion */
        await Parse.Cloud.run('sendCityToAdminEmail', eData).then((result) => {
          console.log('Email successful')
          this.isSubmitingAvailibility = true
          this.errorMessage = 'Thank you, DriverX will be in touch to book your road test and prep lesson.'
          this.sheet3 = false
          this.errorModal = true
        })
        this.isSubmitingAvailibility = false
      } catch (error) {
        this.isSubmitingAvailibility = false
        this.errorMessage = `${error}`
        this.errorModal = true
        console.log('Error in storeBookingRequest =', error)
      }
    },
    async studentFreeBookingsAvailale(studentId) {
      /**
       * getting student package id.
       */
      const student = await new Parse.Query('_User').get(studentId)
      const packageId = student.get('packageId')
      if (!packageId) {
        throw new Error('No packageId found for the student.')
      }
      console.log('Package ID: ', packageId)
      // Step 3: Fetch the package object
      const packageData = await new Parse.Query('SchoolPackages').get(packageId)
      console.log('Package data: ', packageData?.get('freeBookings'))
      this.freeBookings = parseInt(packageData?.get('freeBookings')) || 0
      // Get total utilized hours from all appointments
      this.totalUtilizedHours = await this.getUtilizedHours(studentId)
      console.log('Free Bookings:', this.freeBookings, 'Utilized Hours:', this.totalUtilizedHours)
      if (this.freeBookings > 0) {
        console.log('free bookimg limit ===', this.freeBookings)
        // Step 4: Fetch all appointments for the student
        const studentAppointmentsCount = await this.getBookingRequests(studentId)
        console.log('Raw query results:', studentAppointmentsCount)
        if (studentAppointmentsCount >= this.freeBookings) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    async getUtilizedHours(studentId) {
      try {
        const Appointment = Parse.Object.extend('Appointments')
        const query = new Parse.Query(Appointment)
        const studentPointer = new Parse.Object('_User')
        studentPointer.id = studentId

        query.equalTo('studentId', studentPointer)
        query.containedIn('status', ['Finished', 'Approved'])
        query.limit(1000) // Get all appointments
        const results = await query.find()

        let totalUtilizedHours = 0
        results.forEach(app => {
          const hours = parseFloat(app.get('hoursLesson')) || 0
          totalUtilizedHours += hours
        })

        return totalUtilizedHours
      } catch (error) {
        console.error('Error fetching utilized hours:', error)
        return 0
      }
    },
    async getBookingRequests(studentId) {
      try {
        const BookingRequests = Parse.Object.extend('BookingRequests')
        const Student = Parse.Object.extend('_User')
        // Step 1: Create a pointer to the student
        const studentPointer = new Student()
        studentPointer.id = studentId
        // Step 2: Create a query for the Appointment table
        const bookingQuery = new Parse.Query(BookingRequests)
        // Step 3: Use the pointer to filter appointments
        bookingQuery.equalTo('user', studentPointer)
        bookingQuery.include('user')
        bookingQuery.limit(10)
        // Step 4: Fetch results
        const bookings = await bookingQuery.count()
        /** Also fetch Appointment Request */
        const appointments = await this.getStudentAppointments(studentId)
        console.log('Total Appointments ==', appointments)
        // Step 5: Process the results
        console.log('Total bookings:', bookings)

        return (appointments + bookings)
      } catch (error) {
        console.error('Error fetching student bookings:', error.message)
      }
    },
    async getStudentAppointments(studentId) {
      try {
        const Appointment = Parse.Object.extend('Appointments')
        const Student = Parse.Object.extend('_User')
        // Step 1: Create a pointer to the student
        const studentPointer = new Student()
        studentPointer.id = studentId

        // Step 2: Create a query for the Appointment table
        const appointmentQuery = new Parse.Query(Appointment)

        // Step 3: Use the pointer to filter appointments
        appointmentQuery.equalTo('studentId', studentPointer)
        const totalAppointments = await appointmentQuery.count()
        console.log('Total Appointments (finished + pending):', totalAppointments)
        appointmentQuery.include('studentId')
        appointmentQuery.containedIn('status', ['Finished', 'Approved'])
        appointmentQuery.limit(10)

        // Step 4: Fetch results
        const appointments = await appointmentQuery.count()

        // Step 5: Process the results
        console.log('Total Appointments:', appointments)

        return appointments
      } catch (error) {
        console.error('Error fetching student appointments:', error.message)
      }
    },
    openModal() {
      this.errorDialogModal = true
    },
    closeModal() {
      console.log('Closing selectedRoadTest')
      this.selectedRoadTest = false
      this.errorDialogModal = false
    },
    closeSheet() {
      console.log('Closing selectedRoadTest')
      this.selectedRoadTest = false
      this.sheet = false
    },
    closeSheet3() {
      console.log('Closing selectedRoadTest')
      this.selectedRoadTest = false
      this.sheet3 = false
      console.log('fahad')
    },
    setUser(role) {
      this.userContinue = role
    },
    async openSheet() {
      console.log('Open sheet')
      console.log('this.initialPaymentWarning =', this.initialPaymentWarning)
      console.log('this.prePaid =', this.prePaid)
      console.log(' this.user.id ===', this.user.id)
      console.log(' free booking available =', this.freeBookingAvailable)
      console.log(' totalCompletedHours =====', this.totalCompletedHours)
      const paymentRequired = (
        (this.initialPaymentWarning && !this.paymentMethodAdded && !this.freeBookingAvailable) ||
        (this.totalUtilizedHours >= this.freeBookings && !this.paymentMethodAdded)
      )
      if (
        !paymentRequired
      ) {
        console.log('Payment not required - opening sheet')
        console.log('Inside if')
        this.sheet2 = false
        this.sheet = true
      } else {
        this.sheet = false
        this.sheet2 = false
        console.log('Payment required - showing error modal')
        this.selectedRoadTest = false
        this.errorModal = true
        this.errorMessage = this.totalUtilizedHours >= this.freeBookings
          ? 'Please Add Payment Method. You have used your free bookings hours.'
          : 'Please Add Payment Method.'
        console.log('Inside else')
      }
    },

    openSheet2() {
      const paymentRequired = (
        (this.initialPaymentWarning && !this.paymentMethodAdded && !this.freeBookingAvailable) ||
        (this.totalUtilizedHours >= this.freeBookings && !this.paymentMethodAdded)
      )
      if (
        !paymentRequired
      ) {
        console.log('Inside if')
        this.selectedRoadTest = true
        this.sheet2 = true
        this.sheet = false
      } else {
        this.errorMessage = this.totalUtilizedHours >= this.freeBookings
          ? 'Please Add Payment Method. You have used your free bookings.'
          : 'Please Add Payment Method.'
        this.errorModal = true
        console.log('Inside else')
      }
    },
    closeSheet2() {
      console.log('Closing selectedRoadTest')
      this.selectedRoadTest = false
      this.sheet2 = false
    },
    openSheet3() {
      this.sheet2 = false
      this.sheet3 = true
    },
    closeErrorModal() {
      this.selectedRoadTest = false
      this.errorModal = false
    },
    handleViewInstructor(instructor) {
      // Handle view instructor action - you can navigate to instructor profile or show details
      console.log('View instructor:', instructor)
      // Example: this.$router.push({ name: 'InstructorProfile', params: { id: instructor.id } })
    },
    getOrdinalSuffix(day) {
      if (day > 3 && day < 21) return 'th'

      switch (day % 10) {
        case 1:
          return 'st'
        case 2:
          return 'nd'
        case 3:
          return 'rd'
        default:
          return 'th'
      }
    },
    formatDateTime(date, time) {
      if (!time) return null

      const m = String(time).trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i)
      if (!m) return null

      let h = Number(m[1])
      const min = Number(m[2])
      const suf = m[3].toUpperCase()

      if (suf === 'PM' && h !== 12) h += 12
      if (suf === 'AM' && h === 12) h = 0

      const d = new Date(date)
      d.setHours(h, min, 0, 0)

      // Keep same output format your backend currently uses
      const y = d.getFullYear()
      const mo = String(d.getMonth() + 1).padStart(2, '0')
      const da = String(d.getDate()).padStart(2, '0')
      const hh = String(d.getHours()).padStart(2, '0')
      const mm = String(d.getMinutes()).padStart(2, '0')
      return `${y}/${mo}/${da} ${hh}:${mm}`
    },
    formatDate(date) {
      const options = { weekday: 'long', month: 'long', day: 'numeric' }
      const day = date.getDate()
      const formattedDate = date.toLocaleDateString(undefined, options)
      return formattedDate.replace(day, `${day}${this.getOrdinalSuffix(day)}`)
    },
    ...mapActions([
      'toggleDialog',
      'getSchoolPackageJoinedById',
      'getSchoolInstructors',
      'getInstructorsPackage',
      'getCompletedHours',
      'storeBookingRequest',
      'getAllBookingRequests',
      'getAssignedInstructors'
    ])
  },

  async created() {
    await this.loadWeeklyAvailability()
    this.isLoading = true
    try {
      /**
       * Check if the user have the Pay as you go package and any free booking limit available.
       */
      this.appointmentsCount = await this.getStudentAppointments(this.user.id)
      this.freeBookingAvailable = await this.studentFreeBookingsAvailale(this.user.id)

      /**
       * Fetch assigned instructors for the student
       */
      await this.getAssignedInstructors({
        studentId: this.user.id
      })
      console.clear()
      console.log('haseeb check free booking available== ', await this.studentFreeBookingsAvailale(this.user.id))
      console.log('haseeb check free booking available== ', this.appointmentsCount)
      if (this.user.get('stripePaymentMethodAdded')) {
        this.paymentMethodAdded = true
      }
      console.log(
        "this.user.get('stripePaymentMethodAdded') == ",
        this.user.get('stripePaymentMethodAdded')
      )
      /** Get the school package information this student joined */
      await this.getSchoolPackageJoinedById({
        studentId: this.user.id
      })
      console.log(
        'this.schoolPackageJoinedId ===  ',
        this.schoolPackageJoinedId
      )

      if (this.schoolPackageJoinedId) {
        console.log('haseeb check prepaid== ', this.schoolPackageJoinedId.get('pre_paid'))
        if (this.schoolPackageJoinedId.get('pre_paid') === true) {
          this.prePaid = true
          this.initialPaymentWarning = false
        } else {
          this.prePaid = false
          this.initialPaymentWarning = true
        }
        console.log(
          'Student has joined the school package = ',
          this.schoolPackageJoinedId
        )
        this.schoolName = this.schoolPackageJoinedId
          .get('schoolId')
          .get('name')
        this.signature = this.schoolPackageJoinedId
          .get('schoolId')
          .get('associatedId')
          .get('profilePicture')
        /** bring list of instructors and their packages */
        await this.getSchoolInstructors({
          schoolId: this.schoolPackageJoinedId.get('schoolId').id
        })
        await this.getInstructorsPackage(this.schoolInstructors)
        /** Now show the results */
        this.instructors = this.instructorPackage
        this.schoolPackageId = this.schoolPackageJoinedId.get('schoolPackageId').id
        console.log('this.schoolPackageId === ', this.schoolPackageId)
        /** Show the total completed hours from this school by this student */

        const Appointments = Parse.Object.extend('Appointments')
        const query = new Parse.Query(Appointments)
        const User = Parse.Object.extend('_User')
        const userPointer = new User()
        userPointer.id = this.user.id
        query.equalTo('studentId', userPointer)

        const SchoolPackages = Parse.Object.extend('SchoolPackages')
        const schoolPackagePointer = new SchoolPackages()
        schoolPackagePointer.id = this.schoolPackageJoinedId.get('schoolPackageId').id
        // query.equalTo('schoolPackageId', schoolPackagePointer)

        query.equalTo('status', 'Finished')
        query.limit(1000)

        try {
          const results = await query.find()
          console.log('Appointments found:', results.length)
          results.forEach(app => {
            console.log({
              id: app.id,
              studentId: app.get('studentId')?.id,
              schoolPackageId: app.get('schoolPackageId')?.id,
              status: app.get('status'),
              hoursLesson: app.get('hoursLesson' || 'hourslesson')
            })
          })
          let totalHours = 0
          results.forEach(app => {
            const hours = parseFloat(app.get('hoursLesson')) || 'hourslesson' || 0
            totalHours += hours
          })
          this.totalCompletedHours = totalHours
          console.log('Results === ', results)
          console.log('Total completed hours === ', totalHours)
        } catch (error) {
          console.error('Error fetching completed hours:', error)
          this.totalCompletedHours = 0
        }
      } else {
        // this.$router.push({ name: 'GetStarted' })
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      this.isLoading = false
    }
    const d = new Date()
    const time = d.getHours()

    if (time < 12) {
      this.greeting = 'morning'
    }
    if (time >= 12) {
      this.greeting = 'afternoon'
    }
  }
}
</script>

<style scoped>
.text-box h1 {
  font-weight: normal;
}

.box label {
  position: relative;
  cursor: pointer;
}

.box label input {
  display: none;
}

.box label span {
  position: relative;
  display: inline-block;
  padding: 8px 22px;
  width: auto;
  border: 1px solid rgba(229, 229, 229, 1);
  color: rgba(45, 154, 71, 1);
  border-radius: 8px;
  text-align: center;
  font-size: 14px;
}

.box label span:hover {
  border-color: rgba(45, 154, 71, 1);
  background: rgba(45, 154, 71, 1) !important;
  color: #fff !important;
}

.box label span.yes {
  border-radius: 8px 0 0 8px;
}

.box label span.no {
  border-radius: 0px 8px 8px 0px;
}

.box label input:checked~span {
  color: #fff;
  border-color: rgba(45, 154, 71, 1);
  background: rgba(45, 154, 71, 1);
}

.box.time-box label span {
  background: rgba(245, 245, 245, 1);
  border-radius: 30px;
  font-size: 12px;
  width: auto;
  padding: 8px 12px;
}

.box.time-box label span {
  margin-right: 18px;
  margin-bottom: 18px;
}

.scroll-box {
  max-height: 285px;
  overflow: scroll;
}

.secondary-btn {
  background-color: rgba(244, 250, 246, 1) !important;
  color: rgba(45, 154, 71, 1) !important;
  box-shadow: none;
}

@media screen and (max-width: 580px) {
  h1 {
    font-size: 22px;
  }
}

@media screen and (max-width: 992px) {
  .scroll-holder {
    overflow: auto;
  }
}

.modal-content-holder {
  display: flex;
  align-items: center;
}

.btn-row button {
  padding: 22px !important;
  width: 100%;
  display: flex;
  height: 52px !important;
}

.btn-row button span {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
}

.custom-card {
  background: transparent !important;
  box-shadow: none !important;
}

.not-centred {
  height: unset !important;
  padding: 100px 0 0 0;
}

.center-btn {
  width: fit-content;
  min-width: 210px !important;
  margin: auto;
}

.ceterRow {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10vw 0;

  .col {
    flex: 0 0 auto;
    max-width: 400px;
  }
}
</style>
